<template>
  <div class="app-container" v-cloak>
    <template v-if="isProd !== 'prod'">
      <Toast />
      <Main />
      <div id="tx-toast-container"></div>
    </template>
  </div>
</template>
<style lang="scss">
.app-container {
  overflow: auto;
  // height: 100% !important;
}

</style>
